'use strict';

exports.__esModule = true;
exports.renderDropDownList = exports.renderSelectedOptions = exports.dropDownListTogglerBySearchOptions = exports.dropDownListToggler = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _DropdownMultiSelect = require('./DropdownMultiSelect.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dropDownListToggler = exports.dropDownListToggler = function dropDownListToggler(optionsList, listId) {
  if (optionsList && optionsList.length) {
    var list = document.getElementById(listId);
    if (list.style.display === 'none') {
      list.style.display = 'block';
    } else {
      list.style.display = 'none';
    }
  }
};

var dropDownListTogglerBySearchOptions = exports.dropDownListTogglerBySearchOptions = function dropDownListTogglerBySearchOptions(optionsList, listId) {
  if (optionsList && optionsList.length) {
    var list = document.getElementById(listId);
    if (list.style.display === 'none') {
      list.style.display = 'block';
    }
  }
};

var renderSelectedOptions = exports.renderSelectedOptions = function renderSelectedOptions(optionList) {
  if (optionList.length) {
    var NUMBER_OF_DISPLAYED_VALUES = 2;
    var composedValue = '';
    var checkedItemsCounter = 0;
    var extraItems = 0;
    optionList.forEach(function (item) {
      if (item.isChecked) {
        if (checkedItemsCounter < NUMBER_OF_DISPLAYED_VALUES) {
          if (!composedValue) {
            composedValue = item.fieldValue;
          } else {
            composedValue += ', ' + item.fieldValue;
          }
        } else {
          extraItems += 1;
        }
        checkedItemsCounter += 1;
      }
    });
    return '' + composedValue + (extraItems > 0 ? ' +' + extraItems : '');
  }
};

var renderDropDownList = exports.renderDropDownList = function renderDropDownList(optionsList, callback, extendedStyle) {
  var mappedOptions = [];

  if (optionsList && optionsList.length) {
    mappedOptions = optionsList.map(function (option, index) {
      return _react2.default.createElement(
        _DropdownMultiSelect.ListItem,
        {
          key: option.key,
          extendDropDownListItem: extendedStyle.extendDropDownListItem,
          onClick: function onClick() {
            callback(option, index);
          },
          isMultipleSelection: true
        },
        _react2.default.createElement(
          _DropdownMultiSelect.ItemContentContainer,
          null,
          _react2.default.createElement(_DropdownMultiSelect.CheckBox, { type: 'checkbox', checked: option.isChecked }),
          _react2.default.createElement(
            _DropdownMultiSelect.OptionItemContent,
            { withOutDesciption: !option.description },
            _react2.default.createElement(
              _DropdownMultiSelect.ItemLabel,
              null,
              option.fieldValue
            ),
            option.description && _react2.default.createElement(
              _DropdownMultiSelect.ItemDescription,
              null,
              option.description
            )
          )
        )
      );
    });
  }

  return mappedOptions;
};